export default str => {
  let matches = str.match(/^\#\/detail(?:\/(\d+))+(?:\/([^\/]+))?/)
  return (
    matches && {
      detailId: parseInt(matches[1] || 0),
      assetId: parseInt(matches[2] || 0),
      itemId: parseInt(matches[3] || 0),
      anchor: matches[4],
    }
  )
}
